import { Loading } from "src/components/loading/loading";
import { FolderTile } from "../FolderTile/FolderTile";
import { useListFolders } from "./useListFolders";
import { FolderTileGroup } from "../FolderTile/FolderTileGroup";
import { SessionWithUser } from "src/utils/users/types";
import { useActiveContext } from "shared/ContextSwitcher/store";
import { NewFolderTile } from "../CreateFolder/NewFolderTile";

export function ListFolders({ session }: { session: SessionWithUser }) {
  const activeContext = useActiveContext();
  const results = useListFolders(session, {
    owner: activeContext,
  });

  const foldersCount = results.data?.get_folders.results.length ?? 0;

  const refetchFolders = async () => {
    await results.refetch();
  };

  if (results.loading) {
    return <Loading />;
  }

  return (
    <FolderTileGroup>
      <FolderTile
        icon="folder"
        color="gray"
        name="Creations"
        path="/creations"
        description="Home for your queries and dashboards."
        tiny
      />
      {results.data &&
        results.data.get_folders.results.map((folder) => (
          <FolderTile
            key={folder.id}
            icon={folder.icon}
            color={folder.color}
            name={folder.name}
            path={folder.path}
            description={folder.description ?? undefined}
            tiny
          />
        ))}

      <FolderTile
        icon="archive"
        color="red"
        name="Archived"
        path="/archived"
        description="All your archived queries and dashboards live here."
        tiny
      />

      <NewFolderTile
        foldersCount={foldersCount}
        refetchFolders={refetchFolders}
      />
    </FolderTileGroup>
  );
}
